import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.589 14.2712C15.3297 12.7586 18.5567 11.4802 20.0776 11.03C25.5663 10.0874 28.0705 13.6182 28.9434 14.5781C29.8163 15.538 32.4687 21.846 32.9723 23.2516C33.4759 24.6572 37.0012 28.7711 38.1427 29.3196C39.0559 29.7584 40.4226 32.3022 40.1424 32.3783C39.8929 32.4461 39.5934 32.3726 38.9149 32.3022C36.934 32.0965 30.9914 33.0907 29.447 33.2964C27.9026 33.5021 12.1336 36.8487 10.5103 37.8369C9.21167 38.6275 9.24967 38.1663 9.431 37.8369C9.54122 37.3868 10.1187 35.2845 11.5471 30.4768C13.3326 24.4672 12.6052 23.0492 12.539 20.4158C12.4729 17.7824 13.6632 16.1618 14.589 14.2712Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.7485 32.7944C40.83 30.6035 38.8569 27.5264 37.2926 26.2909C35.2884 24.693 34.0011 23.0952 32.8767 20.7725C31.7047 18.4833 29.0607 13.5427 27.8608 12.0935C26.8764 10.6457 25.168 9.77732 23.9636 9.25777C21.3727 8.43412 18.5375 8.71416 16.1421 9.99906C13.7355 11.3138 9.96482 13.7257 10.6741 22.1355C11.0348 26.412 8.68498 30.6453 8.18625 32.8133C7.68752 34.9813 6.91284 38.1595 7.37654 39.6022",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8588 9.17492C15.8319 7.0709 15.8984 5.43547 17.3961 5.04571C18.8938 4.65594 21.5037 6.1163 21.4889 8.23004",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.976 37.2477C36.3735 36.2534 38.5998 36.0043 40.7658 32.8225C40.4788 31.7967 36.8917 31.6896 35.4478 31.7967C26.423 33.1581 17.7737 34.3778 10.6476 37.2477C9.7123 37.6913 8.81267 38.1802 7.805 38.9735C7.65812 39.4163 7.0117 39.7882 8.14528 40.3181C12.51 40.7924 15.5959 40.3288 19.9935 39.7169",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.563 40.2219C29.563 41.8787 28.2199 43.2219 26.563 43.2219C24.9062 43.2219 23.9702 41.6171 23.563 40.2219C23.1558 38.8266 21.9062 33.3339 23.563 33.3339C25.3109 33.0843 29.563 38.565 29.563 40.2219Z",
			fill: "#1B1B20"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0946 34.7632C24.0501 35.4304 24.2547 37.1117 25.429 38.4995",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBell;
